import templateUrl from './onboarding-application-detail.html'

export const OnboardingApplicationDetailComponent = {
    templateUrl,
    controller: OnboardingApplicationDetailController,
    controllerAs: "vm",
    bindings: {
        onboardingApplication: "<"
    }
}

function OnboardingApplicationDetailController() {
    'ngInject'

    const vm = this;

    vm.onboardingApplication;
    vm.statusHistory;
    vm.referenceFieldHasValue = function (referenceField) {
        return !!referenceField.Value;
    }
}

